var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"register-header-steps d-flex flex m-0 p-0"},_vm._l((_vm.items),function(item,index){return _c('li',{key:item.step,staticClass:"step d-flex align-items-center justify-content-center",class:{
      'step--complete': index < _vm.currentIndex,
      'step--active': index === _vm.currentIndex,
      'step--incomplete': index > _vm.currentIndex,
    }},[_c(item.icon,{tag:"component"}),_vm._v(" "),_c('span',{staticClass:"bar"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }